// import cookie from './cookie';
import { getApiConfig } from '@/mx-service/libs/http/config'
import device from "./device";


export async function is4aLogin(e, toLogin){
  // 美信环境无需单点登录
  if(device.isMission()) return true
  if(window.location.pathname.indexOf("pcv5.html") > -1 || window.location.pathname.indexOf("wapv5.html") > -1){
    toLogin && to4aLogin(e)
    return false
  }
  return true
}

function to4aLogin(id){
  const hostList = getApiConfig()
  console.log('hostList', hostList)
  const url = window.encodeURIComponent(hostList._4aPCUrl + `#/?id=${id}`)
  console.log('url', url)
  window.location.href = hostList._4aUrl + url
}

